import {useNavigate, useNavigation} from "react-router-dom";
import {useEffect} from "react";

export function Redirect() {
    let nav = useNavigate()

    useEffect(() => {
        nav("/decisions")
    }, []);

    
    return (
        <>
        </>
    )
}